import React, { FunctionComponent } from 'react';
import { Box, ToggleButton } from '@mui/material';
import { StyledButtonGroup } from './styles';

interface Props {
  value: 'MAINTENANCE' | 'LANDING';
  onChange: (value: 'MAINTENANCE' | 'LANDING') => void;
}

const TriStateSwitch: FunctionComponent<Props> = ({ value, onChange }) => {
  return (
    <Box sx={{ width: '100%', mb: 3 }}>
      <StyledButtonGroup
        value={value}
        exclusive
        onChange={(_e, newValue) => newValue && onChange(newValue)}
      >
        {/* <ToggleButton value="OFF">Desactivado</ToggleButton> */}
        <ToggleButton value="LANDING">Landing Page</ToggleButton>
        <ToggleButton value="MAINTENANCE">Mantenimiento</ToggleButton>
      </StyledButtonGroup>
    </Box>
  );
};

export default TriStateSwitch;
